import { useMutation, useQuery } from 'react-query';
import stoneAccountServices from './stoneAccount.services';
import notificationError from '@/utils/functions/notificationError';
import { queryClient } from '@/Root';
import { notification } from 'antd';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

export function useStoneAccountList() {
  return useQuery(['stoneAccount/list'], () => stoneAccountServices.list(), {
    enabled: hasPermissions([Authorities.STONE_MANAGER]),
    onError(err) {
      notificationError(err);
    },
  });
}

export function useStoneAccountDetail(id?: number) {
  return useQuery(
    ['stoneAccount/detail', { id }],
    () => stoneAccountServices.detail(id),
    {
      enabled: !!id && hasPermissions([Authorities.STONE_MANAGER]),
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useStoneAccountDetailbyCompany(companyId?: number) {
  return useQuery(
    ['stoneAccount/detail', { id: companyId }],
    () => stoneAccountServices.detailByCompany(companyId),
    {
      enabled: !!companyId && hasPermissions([Authorities.STONE_MANAGER]),
      onError(err) {
        notificationError(err);
      },
    },
  );
}

export function useStoneAccountCreate() {
  return useMutation(stoneAccountServices.create, {
    async onSuccess() {
      notification.success({
        message: 'Dados da conta cadastrado!',
        description: 'Os dados da conta da Stone foram cadastrados com sucesso',
      });
      await queryClient.invalidateQueries(['stoneAccount/list']);
    },

    onError(err) {
      notificationError(err);
    },
  });
}

export function useStoneAccountUpdate() {
  return useMutation(stoneAccountServices.update, {
    async onSuccess(_, vars) {
      notification.success({
        message: 'Dados da conta atualizados!',
        description: 'Os dados da conta da stone foram atualizados com sucesso',
      });
      await queryClient.invalidateQueries([
        'stoneAccount/detail',
        { id: vars.id },
      ]);
      await queryClient.invalidateQueries(['stoneAccount/list']);
    },

    onError(err) {
      notificationError(err);
    },
  });
}

export function useStoneAccountRemove() {
  return useMutation(stoneAccountServices.remove, {
    async onSuccess() {
      notification.success({
        message: 'Conta Stone removida!',
        description: 'O Conta Stone foi removida com sucesso',
      });
      await queryClient.invalidateQueries(['stoneAccount/list']);
    },

    onError(err) {
      notificationError(err);
    },
  });
}
